import EpirocMainPageAPI from 'api/epiroc.mainpage.api';
import { BaseHandler } from './base.handler';
import { setIsLoading } from 'store/epiroc.mainpage.slice';

export default class EpirocMainPageHandler extends BaseHandler {
  private readonly api: EpirocMainPageAPI;

  constructor() {
    super();

    this.api = new EpirocMainPageAPI();
  }

  async getAssetTimeline(startDate: string, endDate: string): Promise<any> {
    try {
      this.dispatch(setIsLoading(true));
      const assetTimeline = await this.api.getAssetTimeline(startDate, endDate);
      // this.dispatch(setSensors(assetTimeline));
      return assetTimeline;
    } catch (e) {
      console.error(e);
      this.handleError(
        'An error occurred while fetching asset timeline details'
      );
    } finally {
      this.dispatch(setIsLoading(false));
    }
  }

  async getShiftWiseDistanceTravelled(
    startDate: string,
    endDate: string
  ): Promise<any> {
    try {
      this.dispatch(setIsLoading(true));
      const shiftWiseDistanceTravelled =
        await this.api.getShiftWiseDistanceTravelled(startDate, endDate);
      // this.dispatch(setShiftWiseDistanceTravelled(shiftWiseDistanceTravelled));
      return shiftWiseDistanceTravelled;
    } catch (e) {
      console.error(e);
      this.handleError(
        'An error occurred while fetching shiftWiseDistanceTravelled details'
      );
    } finally {
      this.dispatch(setIsLoading(false));
    }
  }

  async getLocationTimeline(startDate: string, endDate: string): Promise<any> {
    try {
      this.dispatch(setIsLoading(true));
      const locationTimeline = await this.api.getLocationTimeline(
        startDate,
        endDate
      );
      return locationTimeline;
    } catch (e) {
      console.error(e);
      this.handleError(
        'An error occurred while fetching location timeline details'
      );
    } finally {
      this.dispatch(setIsLoading(false));
    }
  }

  async getEventsInsightsWrtAssetLocationTimestamps({
    startDate,
    endDate,
    assetBase,
    location,
  }: {
    startDate: string;
    endDate: string;
    assetBase: string;
    location: string;
  }): Promise<any> {
    try {
      this.dispatch(setIsLoading(true));
      const eventsInsights =
        await this.api.getEventsInsightsWrtAssetLocationTimestamps({
          startDate,
          endDate,
          assetBase,
          location,
        });
      return eventsInsights;
    } catch (e) {
      console.error(e);
      this.handleError(
        'An error occurred while fetching eventsInsightsWrtAssetLocationTimestamps details'
      );
    } finally {
      this.dispatch(setIsLoading(false));
    }
  }
}
